export default __webpack_public_path__ + "static/media/i3000.94baa775.jpg";